import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import apiService from '../services/api';
import './PaymentSuccess.css';

const PaymentSuccess: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { user } = useAuth();
  const sessionId = searchParams.get('session_id');
  const [userType, setUserType] = useState<string>('standard');

  useEffect(() => {
    if (!user) {
      navigate('/');
      return;
    }

    // Fetch updated user info to get the new plan
    const fetchUserInfo = async () => {
      try {
        const response = await apiService.getUserLimits(user.sub);
        setUserType(response.data.user_type);
      } catch (error) {
        // Error is expected to be handled by the user - they can retry by refreshing
        // or navigate away. Silent failure is acceptable here as it's not critical.
      }
    };

    fetchUserInfo();
  }, [user, navigate]);

  const capitalizedUserType = userType.charAt(0).toUpperCase() + userType.slice(1);

  return (
    <div className="payment-success">
      <div className="success-icon"></div>

      <h1>Payment Successful!</h1>

      <p>
        Thank you for subscribing! Your account has been upgraded to <strong>{capitalizedUserType}</strong> and you now have access to all {userType} features.
      </p>

      <div className="action-buttons">
        <button
          className="primary-button"
          onClick={() => navigate('/upload')}
        >
          Start Using {capitalizedUserType} Features
        </button>

        <button
          className="secondary-button"
          onClick={() => navigate('/settings')}
        >
          View My Profile
        </button>
      </div>

      {sessionId && (
        <div className="subscription-details">
          <h2>Subscription Details</h2>
          <div className="detail-row">
            <span className="detail-label">Status</span>
            <span className="detail-value">Active</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Session ID</span>
            <span className="detail-value">{sessionId.substring(0, 20)}...</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentSuccess;
